.Messages {
  position: relative;
  border: 1px solid $color-red-dull;
  padding: 0 $padding-xxsmall;
  margin: $gutter-small 0;
  background-color: $color-alert-error-soft;
}

.Messages__Close {
  // Full height so the icon stays vertically centred, however many errors are listed.
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  padding: 0 $padding-xxsmall;
  display: flex;
  align-items: center;
  border: 0;
  background: transparent;
  cursor: pointer;

  .Icon {
    @include iconColor($color-red-dull);
    width: 20px;
    height: 20px;
  }

  &:hover .Icon {
    @include iconColor($color-red);
  }
}

.Messages__List {
  display: flex;
  flex-direction: column;
  gap: $gutter-4xsmall;
  padding: $padding-xsmall $padding-xxsmall;
}

// Keep the text clear of the dismiss button.
.Messages--dismissible .Messages__List {
  padding-right: $padding-base;
}

.Messages__Item {
  display: flex;
  gap: $gutter-xxsmall;

  // Stands in for the list marker this used to have.
  &::before {
    content: '•';
    flex: 0 0 auto;
    color: $color-red-dull;
    line-height: 18px;
    font-size: 18px;
    margin-top: 4px;
  }

  small {
    flex: 1 1 auto;
    overflow: hidden;
    // Off the type scale on purpose: 12px reads too small in this box, 14px too loud.
    font-size: 13px;
    line-height: 18px;
  }
}